export class HelpersUtils {
  static appScroll = {
    currentScroll: 0,
    enable: function () {
      document.body.style.overflow = 'auto';
      document.documentElement.style.overflow = 'auto';
    },
    disable: function () {
      document.body.style.overflow = 'hidden';
      document.documentElement.style.overflow = 'hidden';
    },
  };

  static isMobile = {
    Android: function () {
      return navigator.userAgent.match(/Android/i);
    },
    BlackBerry: function () {
      return navigator.userAgent.match(/BlackBerry/i);
    },
    iOS: function () {
      return navigator.userAgent.match(/iPhone|iPad|iPod/i);
    },
    Opera: function () {
      return navigator.userAgent.match(/Opera Mini/i);
    },
    Windows: function () {
      return navigator.userAgent.match(/IEMobile/i);
    },
    any: function () {
      return !!(
        HelpersUtils.isMobile.Android() ||
        HelpersUtils.isMobile.BlackBerry() ||
        HelpersUtils.isMobile.iOS() ||
        HelpersUtils.isMobile.Opera() ||
        HelpersUtils.isMobile.Windows()
      );
    },
  };
  static formatCardNumber(number: string | number | undefined): string | null {
    if (!number) return null;

    const numStr = number.toString();
    return numStr.replace(/(.{4})/g, '$1 ').trim();
  }

  static getSearchQueryTest = (query: string) => {
    if (!query) return new RegExp('(?:)', 'i');
    return new RegExp(query.replace(/([.?*+^$[\]\\(){}|-])/g, '\\$1') + '(?=[^>]*<|(?:[^<>"\']*$))', 'i');
  };

  static downloadPDFViewByData = (data: Blob, name: string, withoutBlobHandler: boolean) => {
    let file = null;
    if (withoutBlobHandler) {
      file = data;
    } else {
      file = new Blob([data], { type: 'application/pdf' });
    }
    const fileURL = URL.createObjectURL(file);
    const link = document.createElement('a');
    link.href = fileURL;
    const linkName = name.replace(/[#_.,\s]/gi, '');
    link.download = linkName + '.pdf';
    link.click();
  };
}
